import React, { useEffect, useRef, useState } from "react";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import {
  generateVideoThumbnail,
  handleDetailResponse,
  handleListResponse,
  isEmpty,
} from "utils/utils";
import {
  getUserListChat,
  getRecentChatList,
  chatStatusUpdate,
  getActivePropertys,
  getPropertyUserList,
} from "reduxStore/action/chatActions";
import { getDatabase, ref, set, onValue, push } from "firebase/database";
import firebaseService from "utils/firebaseConfig";
import {
  getDownloadURL,
  getStorage,
  ref as storeRef,
  uploadBytes,
} from "firebase/storage";
import moment from "moment";
import { seo } from "../../utils/utils";
import { resolveProfileImageSrc } from "utils/profileImage";

import UserList from "./userList";
import VideoModel from "component/common/videoModel";
import ImageRender from "component/common/ImageRender";
import VideoRender from "./VideoRender";
import { AdminRoleId } from "utils/constants";
import PropertyList from "./PropertyList";
const ChatScreenNext = () => {
  const dispatch = useDispatch();
  const storage = getStorage(firebaseService.firebaseApp);
  const database = getDatabase(firebaseService.firebaseApp);
  const [userListChat, setUserListChat] = useState([]);
  const [usersTotal, setUsersTotal] = useState(0);
  const [recentChatList, setRecentChatList] = useState([]);
  const [recentUsersTotal, setRecentUsersTotal] = useState(0);
  const [activeProperties, setActiveProperties] = useState([]);
  const [activeProperty, setActiveProperty] = useState(null);
  const [pageProperties, setPageProperties] = useState(0);
  const [page, setPage] = useState(0);
  const [pageRecentChat, setPageRecentChat] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRecentChat, setIsLoadingRecentChat] = useState(false);
  const [isLoadingProperties, setIsLoadingProperties] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [activeUserChat, setActiveUserChat] = useState(null);
  const [videoDetails, setVideoDetails] = useState(null);
  const [starCountRef, setStarCountRef] = useState(null);
  const messageListRef = useRef(null);
  const chatSelector = useSelector((state) => state.chatResponse);
  const { senderID, senderProfilePicture, senderUserId, senderName, isAdmin } =
    useSelector((state) => {
      const { response, authToken } = state.login;
      if (response && authToken) {
        const result = handleDetailResponse(response.data);
        return {
          senderUserId: result?.user_id,
          senderID: result?.firebase_id,
          senderProfilePicture: result?.profile_picture,
          senderName: result?.user_name,
          isAdmin: result?.role_id === AdminRoleId,
        };
      }
    });

  useEffect(() => {
    const { response, searchResponse, recentChatListResponse, activeProperties } = chatSelector;
    if (response) {
      setIsLoading(false);
      setUserListChat((users) => [
        ...Array.from(
          [...users, ...handleListResponse(response.data)]
            .reduce((m, o) => m.set(o._id, o), new Map())
            .values()
        ),
      ]);
      setUsersTotal(response.total_data)
    }
    if (searchResponse) {
      setIsLoading(false);
      setUserListChat(handleListResponse(searchResponse.data));
    }
    if (recentChatListResponse) {
      setIsLoadingRecentChat(false);
      if (isAdmin) {
        setRecentChatList((users) => [
          ...Array.from(
            [...users, ...handleListResponse(recentChatListResponse.data)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          ),
        ]);
      } else {
        setRecentChatList((users) => [
          ...Array.from(
            [...users.filter(i => i.property_id === activeProperty), ...handleListResponse(recentChatListResponse.data).filter(i => i.property_id === activeProperty)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          ),
        ]);
      }
      setRecentUsersTotal(recentChatListResponse.total_data)
      // setRecentChatList(handleListResponse(recentChatListResponse.data));
      !activeUserChat &&
        setActiveUserChat(handleDetailResponse(recentChatListResponse.data));
    }
    if (activeProperties) {
      if (activeProperties?.status === 200) {
        setActiveProperties((pre) => [
          ...Array.from(
            [...pre, ...handleListResponse(activeProperties.data)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          ),
        ]);
        // setActiveProperties(handleListResponse(activeProperties?.data));
      }
    }
  }, [chatSelector, setIsLoading, setUserListChat, setRecentChatList]);
  useEffect(() => {
    if (isAdmin) {
      dispatch(getUserListChat({ offset: 0, limit: 10 }));
      dispatch(getRecentChatList({ offset: 0, limit: 10 }));
    } else {
      setActiveUserChat(null)
      dispatch(getPropertyUserList())
      setRecentChatList([])
      dispatch(
        getActivePropertys({
          user_id: senderUserId,
          offset: 0, limit: 10
        })
      );
    }

  }, [dispatch]);
  useEffect(() => {
    if (page > 0) {
      setIsLoading(true);
      dispatch(getUserListChat({ offset: page, limit: 10, isLoadMore: true }));
    }
  }, [page, dispatch]);
  useEffect(() => {
    if (pageRecentChat > 0) {
      setIsLoadingRecentChat(true);
      if (isAdmin) {
        dispatch(
          getRecentChatList({
            offset: pageRecentChat,
            limit: 10,
            isLoadMore: true,
          })
        );
      } else {
        dispatch(
          getPropertyUserList({
            property_id: activeProperty,
            offset: pageRecentChat,
            limit: 10,
            isLoadMore: true,
          })
        );
      }
    }
  }, [pageRecentChat, dispatch]);
  useEffect(() => {
    if (pageProperties > 0) {
      setIsLoadingProperties(true);
      dispatch(
        getActivePropertys({
          user_id: senderUserId,
          offset: pageProperties,
          limit: 10,
          isLoadMore: true,
        })
      );
    }
  }, [pageProperties, dispatch]);
  useEffect(() => {
    if (isAdmin) {
      if (searchText.length > 1) {
        setIsLoading(true);
        dispatch(
          getUserListChat({
            user_name: searchText,
            isLoadMore: true,
            isSearch: true,
            offset: 0,
            limit: 10,
          })
        );
      } else {
        dispatch(
          getUserListChat({
            offset: 0,
            limit: 10,
            isLoadMore: true,
          })
        );
      }
    }
  }, [searchText, dispatch]);
  const loadMore = () => {
    setPage((page) => page + 1);
  };
  const loadMoreProperties = () => {
    setPageProperties((page) => page + 1);
  };
  const loadMoreRecentChat = () => {
    setPageRecentChat((page) => page + 1);
  };

  const handleUserChat = (item) => {
    const starCountRef = ref(
      database,
      senderID > item?.firebase_id
        ? senderID + "-" + item?.firebase_id
        : item?.firebase_id + "-" + senderID
    );
    setStarCountRef(starCountRef)
    setActiveUserChat({ ...item });
  };
  const handleClickProperty = (item) => {
    setMessages([]);
    setActiveUserChat(null);
    setActiveProperty(item);
    dispatch(
      getPropertyUserList({
        property_id: item,
        offset: 0,
        limit: 10,
        isLoadMore: true,
      })
    );
  };
  const groupedDays = (chatListData) => {
    return chatListData.reduce((acc, el, i) => {
      const messageDay = moment(el.createdAt).format("YYYY-MM-DD");
      if (acc[messageDay]) {
        return { ...acc, [messageDay]: acc[messageDay].concat([el]) };
      }
      return { ...acc, [messageDay]: [el] };
    }, {});
  };
  const generateItems = (chatListData) => {
    const days = groupedDays(chatListData);
    const sortedDays = Object.keys(days).sort(
      (x, y) => moment(y, "YYYY-MM-DD").unix() - moment(x, "YYYY-MM-DD").unix()
    );
    const item = sortedDays.reduce((acc, date) => {
      const sortedMessages = days[date].sort(
        (x, y) => +new Date(y.createdAt) - +new Date(x.createdAt)
      );
      return acc.concat([...sortedMessages, { type: "day", date, id: date }]);
    }, []);
    return item;
  };
  const getMsgList = async (item, starCountRef) => {

    onValue(starCountRef, async (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // var copy = Object.keys(snapshot?.val());
        // setkeys(copy);
        const message_array = [];
        snapshot.forEach((childSnapshot) => {
          message_array.push({
            msgId: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        const msgArray = generateItems(
          message_array.filter((i) => i?.["delete-" + senderID] === false)
        );
        const finalChatArray = []
        await msgArray.map(async (items) => {
          if (
            items?.text !== "" ||
            items?.image !== "" ||
            items?.video !== ""
          ) {
            let img =
              items?.senderUserId === senderID
                ? senderProfilePicture
                : activeUserChat?.profile_picture;


            if (((items?.senderUserId === senderID && items?.recevierID === activeUserChat?.firebase_id)
              || (items?.senderUserId === activeUserChat?.firebase_id && items?.recevierID === senderID)
            )) {
              finalChatArray.push({
                _id: items?.msgId,
                text: items?.text,
                image: items?.image,
                video_thumbnail: items?.video_thumbnail,
                senderUserId: items?.senderUserId,
                recevierID: items?.recevierID,
                filename: items?.filename,
                type: items?.type,
                video: items?.video,
                createdAt: items?.createdAt,
                user: {
                  _id:
                    items?.senderUserId === senderID
                      ? senderUserId
                      : activeUserChat?._id,
                  name:
                    items?.senderUserId === senderID
                      ? senderName
                      : activeUserChat?.user_name,
                  avatar: activeUserChat?.base_url + "/" + img,
                },
              })
            }
          }
        });
        const chatArr = finalChatArray
          .filter((i) => i?._id)
          .sort((x, y) => new Date(x.createdAt) - new Date(y.createdAt))

        console.log('chatArr: ', chatArr);
        setMessages(handleListResponse(chatArr));
      } else {
        setMessages([]);
      }
    });
  };
  useEffect(() => {
    if (!isEmpty(activeUserChat)) {
      getMsgList(activeUserChat, starCountRef);
      dispatch(
        chatStatusUpdate({
          receiver_id: activeUserChat?._id,
          msg_status: 2,
          isLoadMore: true,
        })
      );
    }
  }, [activeUserChat, starCountRef, dispatch]);
  const _handleChatSend = async () => {
    const params = {
      createdAt: new Date().toISOString(),
      text: inputValue.trim(),
      senderUserId: senderID,
      recevierID: activeUserChat?.firebase_id,
      _id: senderID,
      ["isRead-" + senderID]: true,
      ["isRead-" + activeUserChat?.firebase_id]: false,
      isDelete: false,
      ["delete-" + senderID]: false,
      ["delete-" + activeUserChat?.firebase_id]: false,
    };

    if (inputValue.trim() !== "") {
      const postListRef = ref(
        database,
        senderID > activeUserChat?.firebase_id
          ? senderID + "-" + activeUserChat?.firebase_id
          : activeUserChat?.firebase_id + "-" + senderID
      );
      const newPostRef = push(postListRef);
      set(newPostRef, params);
      setInputValue("");
      dispatch(
        chatStatusUpdate({
          receiver_id: activeUserChat?._id,
          msg_status: 1,
          isLoadMore: true,
        })
      );
    }
  };
  // moment.updateLocale("en", {
  //   relativeTime: {
  //     future: "in %s",
  //     past: "%s ago",
  //     s: "a few seconds",
  //     ss: "%d seconds",
  //     m: "a minute",
  //     mm: "%d minutes",
  //     h: "an hour",
  //     hh: "%d hours",
  //     d: "a day",
  //     dd: "%d days",
  //     w: "a week",
  //     ww: "%d weeks",
  //     M: "a month",
  //     MM: "%d months",
  //     y: "a year",
  //     yy: "%d years",
  //   },
  // });
  const scrollToBottom = () => {
    messageListRef.current?.scroll({
      top: messageListRef.current?.scrollHeight,
      behavior: "smooth",
    });
    // messageListRef.current?.scrollIntoView({
    //   // block: "nearest",
    //   // inline: "center",
    //   behavior: "smooth",
    //   alignToTop: false,
    // });
  };

  useEffect(() => {
    seo({
      title: "User Chat Box",
      metaDescription: "User chat box",
      canonicalLink: window.location.href,
    });
  }, []);
  const handleAttachPress = async (e) => {
    let files = e.target.files;
    for (let file = 0; file < files.length; file++) {
      let mediaObject = {
        filename: files[file].name,
        url: "",
        type: "",
      };
      let type, mediaPath, video_thumbnail;
      if (
        files[file].type === "image/jpeg" ||
        files[file].type === "image/JPEG" ||
        files[file].type === "image/jpg" ||
        files[file].type === "image/JPG" ||
        files[file].type === "image/png" ||
        files[file].type === "image/PNG"
      ) {
        mediaPath = `images/${files[file].name}`;

        type = "image";
      } else if (files[file].type === "application/pdf") {
        mediaPath = `docFiles/${files[file].name}`;

        type = "doc";
      } else if (files[file].type === "video/mp4") {
        mediaPath = `videos/${files[file].name}`;
        type = "video";
        video_thumbnail = await generateVideoThumbnail(files[file]);
      }
      const storageRef = storeRef(storage, mediaPath);
      uploadBytes(storageRef, files[file]).then(async (snapshot) => {
        var dwnload = await getDownloadURL(storageRef);
        mediaObject = {
          ...mediaObject,
          type: type,
          url: dwnload,
        };
        if (mediaObject.url !== "") {
          const params = {
            createdAt: new Date().toISOString(),
            [mediaObject.type === "doc" ? "image" : mediaObject.type]: dwnload,
            type: mediaObject.type,
            filename: mediaObject.filename,
            video_thumbnail: video_thumbnail ? video_thumbnail : "",
            senderUserId: senderID,
            recevierID: activeUserChat?.firebase_id,
            _id: senderID,
            ["isRead-" + senderID]: true,
            ["isRead-" + activeUserChat?.firebase_id]: false,
            isDelete: false,
            ["delete-" + senderID]: false,
            ["delete-" + activeUserChat?.firebase_id]: false,
          };

          const postListRef = ref(
            database,
            senderID > activeUserChat?.firebase_id
              ? senderID + "-" + activeUserChat?.firebase_id
              : activeUserChat?.firebase_id + "-" + senderID
          );
          const newPostRef = push(postListRef);
          set(newPostRef, params);
          setInputValue("");
          dispatch(
            chatStatusUpdate({
              receiver_id: activeUserChat?._id,
              msg_status: 1,
              isLoadMore: true,
            })
          );
        }
      });
    }
  };
  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom();
    }
  }, [messages]);
  const renderMessage = (msg) => (
    <div className={`conversation-list`}>
      <div className="chat-avatar">
        <img
          src={resolveProfileImageSrc({
            preview: msg?.user?.avatar,
          })}
          alt="chatvia"
        />
      </div>
      <div className="user-chat-content">
        <div className="ctext-wrap">
          <div className="ctext-wrap-content">
            <p className="mb-0">{msg?.text}</p>
            {msg?.image &&
              msg?.type === "image" && (
                <ImageRender
                  imageUrl={msg?.image}
                  thumbnailUrl={msg?.image}
                />
              )}
            {msg?.image &&
              msg?.type === "doc" && (
                <div className="col-md-2">
                  <a
                    href={msg?.image}
                    target={"_blank"}
                  >
                    <img
                      src="/assets/images/attachment-2.jpg"
                      className="view_pro"
                      alt={msg?.image}
                    />
                  </a>
                </div>
              )}
            {msg?.video &&
              msg?.type === "video" && (
                <VideoRender
                  setVideoDetails={
                    setVideoDetails
                  }
                  videoThumbnail={
                    msg?.video_thumbnail
                  }
                  videoUrl={msg?.video}
                />
              )}
            <p className="chat-time mb-0">
              <i className="ri-time-line align-middle"></i>{" "}
              <span className="align-middle">
                {moment(msg?.createdAt).fromNow(
                  true
                )}
              </span>
            </p>
          </div>
          <div className="align-self-start dropdown">
            <a
              aria-haspopup="true"
              className=""
              aria-expanded="false"
            >
              <i className="ri-more-2-fill"></i>
            </a>
          </div>
        </div>
        {/* <div className="conversation-name">
                                          {msg?.user?.name}
                                        </div> */}
      </div>
    </div>
  )
  return (
    <div className="page-body">
      <VideoModel data={videoDetails} />
      <Breadcrumb title={strings.chatScreen} titleactive={strings.chat} isBackBtn={true} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body p-2">
                <div className="row chat-box">
                  {/* <!-- Chat right side start--> */}
                  <div className="col-12 pr-0 chat-right-aside">
                    {/* <!-- chat start--> */}
                    {!isEmpty(activeUserChat) ? (
                      <div className="chat">
                        {/* <!-- chat-header start--> */}
                        <div className="chat-header clearfix">
                          <div className="p-1 pl-1">
                            <img
                              className="rounded-circle"
                              src={resolveProfileImageSrc({
                                baseUrl: activeUserChat?.base_url,
                                profilePicture: activeUserChat?.profile_picture,
                              })}
                              alt={activeUserChat?.user_name}
                            />
                            <div className="about">
                              <div className="name">
                                {activeUserChat?.user_name}
                                <span className="font-primary f-12"></span>
                              </div>
                              <div className="status">
                                {activeUserChat?.roles}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- chat-header end--> */}
                        <div
                          className="chat-history chat-msg-box custom-scrollbar"
                          ref={messageListRef}
                        >
                          <ul className="list-unstyled">
                            {messages.length > 0
                              ? messages.map((msg, index) => (
                                <li
                                  className={
                                    senderID === msg?.senderUserId
                                      ? "float-right"
                                      : ""
                                  }
                                  key={index}
                                >
                                  {/* {((msg?.recevierID === senderID && msg?.senderUserId === activeUserChat?.firebase_id)
                                    || (msg?.recevierID === activeUserChat?.firebase_id && msg?.senderUserId === senderID)
                                  ) && renderMessage(msg)} */}
                                  {renderMessage(msg)}
                                </li>
                              ))
                              : null}
                            {/* <div ref={messageListRef} /> */}
                          </ul>
                        </div>
                        {/* <!-- end chat-history--> */}
                        <div className="chat-message clearfix">
                          <div className="row">
                            <div className="col-xl-12 d-flex">
                              <div className="input-group text-box">
                                <input
                                  className="form-control input-txt-bx"
                                  id="message-to-send"
                                  type="text"
                                  autoComplete="off"
                                  name="message-to-send"
                                  value={inputValue}
                                  onChange={(e) =>
                                    setInputValue(e.target.value)
                                  }
                                  placeholder={strings.typeAmessage}
                                />

                                <div className="input-group-append">
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    disabled={isEmpty(inputValue)}
                                    onClick={_handleChatSend}
                                  >
                                    {strings.send}
                                  </button>
                                </div>
                              </div>
                              <div className="row align-items-center pl-3">
                                <input
                                  id="file-to-send"
                                  type="file"
                                  autoComplete="off"
                                  name="file-to-send"
                                  accept="image/*,video/*,.pdf"
                                  style={{ display: "none" }}
                                  // value={inputValue}
                                  onChange={handleAttachPress}
                                  tabIndex="-1"
                                  aria-hidden="true"
                                  placeholder={strings.typeAmessage}
                                />
                                <label
                                  htmlFor="file-to-send"
                                  className="breadcrumb-item pt-2"
                                >
                                  <i
                                    className="icon-clip"
                                    style={{ fontSize: 25 }}
                                  ></i>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="chat">
                        <div className="load-more">{strings.userNotSelect}</div>
                        <div className="load-more">
                          {strings.startChat}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChatScreenNext;
